import { AssetType } from '@compass/client/types/asset';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useCaseRecordAssets } from '@/hooks/useCaseRecordAssets';
import { useDownloadPdf } from '@/hooks/useDownloadPdf';
import { useFaxes } from '@/hooks/useFaxes';

export const useFax = () => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const { caseId } = useParams<{ caseId: string }>();
  const { downloadPdf, isDownloading } = useDownloadPdf(caseId || null);
  const { data: faxesData } = useFaxes(caseId || null);
  const { data: faxAssets = [] } = useCaseRecordAssets(caseId || null, AssetType.ASSET_TYPE_FAX);
  useEffect(() => {
    if (faxAssets.length > 0 && faxAssets[0]?.id && !pdfBlobUrl && !isDownloading) {
      const assetId = faxAssets[0].id;
      downloadPdf(assetId)
        .then(blobUrl => {
          if (blobUrl) {
            setPdfBlobUrl(blobUrl);
          }
        })
        .catch(err => {
          console.error('Failed to load fax PDF:', err);
        });
    }
  }, [faxAssets, downloadPdf, pdfBlobUrl, isDownloading]);

  return {
    pdfBlobUrl,
    faxesData,
  };
};
